export default {
  namespaced: true,
  state: {
    form: {},
    fetchData: {}
  },
  actions: {
    updateForm({ commit }, form) {
      return commit('SET_FORM', form);
    },
    updateFetchData({ commit }, data) {
      return commit('SET_FETCH_DATA', data);
    },
    clearForm({ commit }) {
      return commit('CLEAR_FORM');
    }
  },
  getters: {
    form: state => state.form,
    fetchData: state => state.fetchData,
    value: state => field => state.form[field]
  },
  mutations: {
    SET_FORM: (state, form) => {
      state.form = form;
    },
    CLEAR_FORM: state => {
      state.form = {};
    },
    SET_FETCH_DATA: (state, data) => {
      state.fetchData = data;
    }
  }
};
